// Settings and Reports list their sections the same way: the open one takes its area's tint.
import type { Area } from '@ims/ui'

// The section you are on takes its area's tint, like the sidebar (from `md`: a phone shows
// the list alone, with nothing chosen). Spelled out so Tailwind sees every class.
export const SECTION_ACTIVE: Record<Area, string> = {
  sell: 'md:bg-sell-wash md:text-sell md:ring-sell-light',
  people: 'md:bg-people-wash md:text-people md:ring-people-light',
  stock: 'md:bg-stock-wash md:text-stock md:ring-stock-light',
  buy: 'md:bg-buy-wash md:text-buy md:ring-buy-light',
  insight: 'md:bg-insight-wash md:text-insight md:ring-insight-light',
  kitchen: 'md:bg-kitchen-wash md:text-kitchen md:ring-kitchen-light',
  neutral: 'md:bg-neutral-wash md:text-neutral md:ring-neutral-light',
  take: 'md:bg-take-wash md:text-take md:ring-take-light',
}
